export default __webpack_public_path__ + "static/media/AdobeStock_229945720_Preview.33718170.jpeg";